import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import "./index.css";
import { initializeConfig } from "./config";

// Wait for public/config.json before mounting.
// Otherwise early boot calls (maintenance, permissions) race and use the
// hardcoded production fallback https://fb.dataklout.com from config.js,
// even when testing points API_BASE_URL at another host.
initializeConfig().then(() => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
});
